import { render, staticRenderFns } from "./UsersSingle.vue?vue&type=template&id=c5159e70"
import script from "./UsersSingle.vue?vue&type=script&lang=js"
export * from "./UsersSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports